import { useDispatch, useSelector } from 'react-redux'
import { useState, useEffect } from 'react'
import { teamService } from '../services/team'
import { setUpperPopup } from '../store/reducers/general'
import { Details } from '../cmps/team/details.jsx'
import { Members } from '../cmps/team/members.jsx'
import { Departments } from '../cmps/team/departments.jsx'
import { Login } from './login.jsx'

export function Team() {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const team = useSelector(state => state.user.currentTeam)
    const userRoles = team?.members?.find(member => member._id === user._id)?.roles || []
    const [teamVideos, setTeamVideos] = useState({})
    const [activeTab, setActiveTab] = useState('members')
    const isAdmin = userRoles.includes('admin')

    useEffect(() => {
        if (isAdmin) loadTeamVideos()
    }, [team.channelName])

    const loadTeamVideos = async () => {
        try {
            const videos = await teamService.getTeamVideos(team._id)
            setTeamVideos(videos)
        }
        catch (err) {
            console.log(err)
            dispatch(setUpperPopup('error-loading-team-videos'))
        }
    }

    if (!user._id) return <Login />

    return <div className="profile team">
        <Details team={team} isAdmin={isAdmin} />
        <div className='team-tabs'>
            <p className={activeTab === 'members' ? 'active' : ''} onClick={() => setActiveTab('members')}>חברי צוות</p>
            <p className={activeTab === 'departments' ? 'active' : ''} onClick={() => setActiveTab('departments')}>מחלקות</p>
        </div>
        {activeTab === 'members' && <Members teamVideos={teamVideos} />}
        {activeTab === 'departments' && <Departments teamVideos={teamVideos} />}
    </div>
}